// import { FieldProps } from "formik";
import React from "react";
import Select from "react-select";
import Creatable from "react-select/creatable"
// import { OptionsType, ValueType } from "react-select/lib/types";

// interface Option {
//   label: string;
//   value: string;
// }

// interface CustomSelectProps extends FieldProps {
//   options: OptionsType<Option>;
//   isMulti?: boolean;
//   className?: string;
//   placeholder?: string;
// }

export const CustomReactSelect = ({
  className,
  placeholder,
  name,
  setValue, 
  getValues,
//   field,
//   form,
  options,
  isMulti = false,
  newSelection,
  updateOptions,
  maxOptions
}) => {
  
  const handleChange = (option) => {

    console.log("Handling change: ", option)
    if (isMulti && maxOptions && option && option.length > maxOptions) {
      window.alert(`Max allowed: ${maxOptions}`)
      return
    }
    
    const newOption = isMulti ? (option ?? []).map((item) => item.value) : (option).value;
    // console.log(newOption)
    if (newSelection) {
      newSelection(newOption)
    }
    setValue(name,newOption)
    // form.setFieldValue(
    //   field.name,
    //   newOption
    // );
  };

  const handleCreateOption = (newOption) => {

    newOption = {
      label: newOption,
      value: newOption
    }
    // const newOption = []
    // const newOptions = [...options, {
    //   label: newOption,
    //   value: newOption
    // }]
    // const newOptions = [newOption]

    if (updateOptions) {
      updateOptions([newOption])
    }
    handleChange([newOption])

  //   onCreateOption={(newOption) => {
  //     setPossibleCategories([...possibleCategories, {
  //         label: newOption,
  //         value: newOption}])
  //     console.log("creating option: ", newOption)
  // }}
  }

  const getValue = () => {
    if (options) {
      return isMulti
        ? options.filter(option => getValues(name).indexOf(option.value) >= 0)
        : options.find(option => option.value === getValues(name));
    } else {
      return isMulti ? [] : ("");
    }
  };

  return (<>
    {/* <Creatable 
      className={className}
      name={name}
      value={getValue()}
      onChange={handleChange}
      onCreateOption={(e) => {
        handleCreateOption(e)
      }}
      placeholder={placeholder}
      options={options}
      isMulti={isMulti}
      /> */}
    {updateOptions ? (
      <Creatable 
      className={className}
      name={name}
      value={getValue()}
      onChange={handleChange}
      onCreateOption={(e) => {
        handleCreateOption(e)
      }}
      placeholder={placeholder}
      options={options}
      isMulti={isMulti}
      />
    ) : (
      <Select
      className={className}
      name={name}
      value={getValue()}
      onChange={handleChange}
      onCreateOption={(e) => {
        handleCreateOption(e)
      }}
      placeholder={placeholder}
      options={options}
      isMulti={isMulti}
      theme={(theme) => ({
        ...theme,
        colors: {
        ...theme.colors,
          primary25: '#CECECE',
          primary50: '#CECECE',
          primary75: '#ACABAB',
          primary: '#9B9B9B'
        },
      })}
      menuPortalTarget={document.body} 
      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />
    )}

    
  </>);
};

export default CustomReactSelect;
